import React from 'react'

// import EmptyBar from 'ROOT_SOURCE/components/EmptyBar'
import './index.scss'

// 运营报告
class Report extends React.PureComponent {

    constructor() {
        super();
        this.state = {
            activeBar: 1
        }
    }

    changeActiveBar(num) {
        this.setState({ activeBar: num });
    }

    render() {
        const { activeBar } = this.state;
        return (
            <div className="Report">
                <div className="navbar">
                    <p
                        className={activeBar === 1 ? 'active' : ''}
                        onClick={this.changeActiveBar.bind(this, 1)}
                    >2019年半年度</p>
                    <p
                        className={activeBar === 2 ? 'active' : ''}
                        onClick={this.changeActiveBar.bind(this, 2)}
                    >2018年年度</p>
                    <p
                        className={activeBar === 3 ? 'active' : ''}
                        onClick={this.changeActiveBar.bind(this, 3)}
                    >2017年年度</p>
                </div>
                <div className="img-box">
                    {
                        activeBar === 1 ? (<img src="//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E8%BF%90%E8%90%A5%E6%8A%A5%E5%91%8A2019-pc.png?t=2" alt="五八钱柜运营报告2019" />) : null
                    }
                    {
                        activeBar === 2 ? (<img src="//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E8%BF%90%E8%90%A5%E6%8A%A5%E5%91%8A2018-pc.png?t=2" alt="五八钱柜运营报告2018" />) : null
                    }
                    {
                        activeBar === 3 ? (<img src="//j1.58cdn.com.cn/jinrong/licai/pc/%E4%BA%94%E5%85%AB%E9%92%B1%E6%9F%9C%E8%BF%90%E8%90%A5%E6%8A%A5%E5%91%8A2017-pc.png?t=2" alt="五八钱柜运营报告2017" />) : null
                    }
                </div>
            </div>
        )
    }
}

export default Report;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/Report/index.js